import { connect } from 'react-redux';
import ManageGeneralJournal from '../../../../views/Finance/Bookkeeping/GeneralJournal/ManageGeneralJournal.bookkeeping.view';
import { getGeneralJournalById, manageGeneralJournal } from '../../../../states/thunks/finance.thunk';
import { getCoaOptions } from '../../../../states/thunks/options.thunk';

function mapStateToProps(state) {
  return {
    coa: state.options.coa,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleGetCoa: payload => dispatch(getCoaOptions(payload)),
    handleGetGeneralJournal: payload => dispatch(getGeneralJournalById(payload)),
    handleManageGeneralJournal: (payload, goBack) => (
      dispatch(manageGeneralJournal(payload, goBack))
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageGeneralJournal);
